import { BRANDS } from "../data/site";

export default function BrandStrip() {
  const items = [...BRANDS, ...BRANDS]; // duplicate for seamless marquee
  return (
    <section
      data-testid="brand-strip"
      className="bg-[#F8FAFC] border-y border-[#E2E8F0] py-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 lg:px-8 flex items-center gap-3 mb-6">
        <span className="slash-divider"></span>
        <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#475569]">
          Authorised Brands We Stock
        </span>
      </div>
      <div className="overflow-hidden">
        <div className="marquee-track flex items-center gap-12 px-6">
          {items.map((b, i) => (
            <div
              key={`${b.name}-${i}`}
              className="flex items-center justify-center h-14 px-5 min-w-[140px] grayscale hover:grayscale-0 opacity-70 hover:opacity-100 transition-all"
            >
              {b.logo ? (
                <img
                  src={b.logo}
                  alt={b.name}
                  className="max-h-12 max-w-[140px] object-contain"
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.replaceWith(
                      Object.assign(document.createElement("span"), {
                        className: "font-head font-black text-2xl text-[#0A192F] tracking-tight",
                        textContent: b.name,
                      })
                    );
                  }}
                />
              ) : (
                <span className="font-head font-black text-2xl text-[#0A192F] tracking-tight">
                  {b.name}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
